import { createSelector } from 'reselect';
import { basicSelectorWithStats, basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
// @ts-expect-error no declarations found for module
import { getSectionById } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getSectionWidgetsHelper, getElements } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getSavedSectionsRequest, getSaveSectionRequest } from 'EmailEditorUI/redux/selectors/requestStatesSelectors';
import { requestStarted, requestCompleted, requestUninitialized } from 'redux-request-state/util/requestStateCheckers';
const getSavedSectionData = basicSelector(state => state.savedSections);
const createSavedSectionsSelector = property => createSelector(getSavedSectionData, savedSectionsData => savedSectionsData[property]);
const getSavedSectionsMetadata = createSavedSectionsSelector('sectionsMetadata');
const getIsLoadingRequest = request => requestStarted(request) && !requestCompleted(request);
const getWillLoadRequest = request => getIsLoadingRequest(request) || requestUninitialized(request);
export const getShowLoadingStateForAllSections = createSelector(getSavedSectionsRequest, getWillLoadRequest);
export const getShowLoadingStateForSavingSection = createSelector(getSaveSectionRequest, getIsLoadingRequest);
export const getSavedSections = createSavedSectionsSelector('sections');
const isFavorited = section => {
  var _section$userMeta;
  return (_section$userMeta = section.userMeta) === null || _section$userMeta === void 0 ? void 0 : _section$userMeta.isFavorited;
};
export const getSavedSectionsOrdered = createSelector([getSavedSections], sections => {
  return sections ? Object.values(sections).sort((a, b) => {
    if (isFavorited(a) === isFavorited(b)) {
      return a.updated - b.updated;
    } else if (isFavorited(a)) {
      return -1;
    }
    return 1;
  }) : [];
});
export const getSavedSectionsTotal = createSavedSectionsSelector('total');
export const getSavedSectionsOffset = createSavedSectionsSelector('offset');
export const getSelectedSectionAndWidgetsById = basicSelectorWithStats((state, id) => {
  const section = getSectionById(state, id);
  const allElements = getElements(state);
  const sectionElementIds = getSectionWidgetsHelper(section);
  const widgets = allElements.filter(element => sectionElementIds.includes(element.get('id')));
  return {
    section,
    widgets
  };
});
export const getSavedSectionByPath = basicSelectorWithStats((state, path) => {
  return getSavedSections(state)[path];
});
export const getSavedSectionMetadata = basicSelectorWithStats((state, path) => {
  return getSavedSectionsMetadata(state)[path];
});